export interface VerticalBounds {
  top: number;
  bottom: number;
}

// How far a scroll container must move so `target` sits fully inside
// `viewport`: positive scrolls down, negative scrolls up, 0 when it already
// fits. A target taller than the viewport is aligned to its top.
export function scrollDeltaToReveal(target: VerticalBounds, viewport: VerticalBounds): number {
  if (target.top < viewport.top) {
    return target.top - viewport.top;
  }
  const overflowBelow = target.bottom - viewport.bottom;
  const room = target.top - viewport.top;
  return overflowBelow > 0 ? Math.min(overflowBelow, room) : 0;
}
